const esc = (s) => String(s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
const money = (n) => `$${Number(n || 0).toFixed(2).replace(/\.00$/, "")}`;

const card = (g, origin) => `
<div class="card">
  <div class="stripe"></div>
  <div class="inner">
    <div class="top">
      <img class="logo" src="${origin}/cake-society-logo.png" alt="Cake Society" />
      <span class="tag">Gift Card</span>
    </div>
    <div class="amount">${money(g.amount)}</div>
    <div class="people">
      <div><span>To</span>${esc(g.recipient_name || "")}</div>
      <div><span>From</span>${esc(g.buyer_name || "Cake Society")}</div>
    </div>
    ${g.message ? `<p class="msg">&ldquo;${esc(g.message)}&rdquo;</p>` : `<p class="msg muted">A few sweet hours in the studio — on us.</p>`}
    <div class="bottom">
      <div class="code"><span>Gift code</span><b>${esc(g.code)}</b></div>
      <p class="how">Redeem at checkout on classes, camps, tutorials &amp; the shop.<br/>Check your balance at ${esc(origin.replace(/^https?:\/\//, ""))}/gift</p>
    </div>
  </div>
</div>`;

// Prints gift cards as 7"×5" cards, two per letter-size sheet, with cut lines.
export function openGiftCardPrint(gifts) {
  const origin = window.location.origin;
  const pages = [];
  for (let i = 0; i < gifts.length; i += 2) pages.push(gifts.slice(i, i + 2));
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>Gift card${gifts.length > 1 ? "s" : ""} — Cake Society</title>
<style>
  @page { size: letter portrait; margin: 0; }
  * { box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  body { margin: 0; font-family: Montserrat, Arial, sans-serif; color: #121212; background: #ddd; }
  .sheet { width: 8.5in; height: 11in; background: #fff; margin: 0 auto 16px; display: flex; flex-direction: column; align-items: center; justify-content: space-evenly; page-break-after: always; }
  .slot { width: 7in; height: 5in; outline: 1px dashed #bbb; outline-offset: 0.12in; }
  .card { position: relative; width: 7in; height: 5in; background: #F2E9D8; overflow: hidden; border: 2px solid #121212; }
  .stripe { position: absolute; left: 0; top: 0; bottom: 0; width: 0.35in; background: #C6FF33; border-right: 2px solid #121212; }
  .inner { position: absolute; inset: 0.35in 0.4in 0.3in 0.75in; display: flex; flex-direction: column; }
  .top { display: flex; justify-content: space-between; align-items: center; }
  .logo { height: 0.42in; }
  .tag { font-size: 10px; letter-spacing: .35em; text-transform: uppercase; font-weight: 700; background: #121212; color: #C6FF33; padding: 6px 12px; }
  .amount { font-family: Georgia, 'Playfair Display', serif; font-weight: 900; font-size: 1.15in; line-height: 1; margin-top: 0.2in; }
  .people { display: flex; gap: 0.5in; margin-top: 0.12in; font-size: 15px; font-weight: 700; }
  .people span { display: block; font-size: 9px; letter-spacing: .3em; text-transform: uppercase; color: #E0218A; font-weight: 700; margin-bottom: 2px; }
  .msg { font-family: Georgia, serif; font-style: italic; font-size: 14px; margin: 0.14in 0 0; max-height: 0.6in; overflow: hidden; }
  .msg.muted { color: #555; }
  .bottom { margin-top: auto; display: flex; align-items: flex-end; justify-content: space-between; gap: 0.2in; }
  .code { background: #fff; border: 2px solid #121212; padding: 8px 14px; }
  .code span { display: block; font-size: 8px; letter-spacing: .3em; text-transform: uppercase; color: #777; }
  .code b { font-family: 'Courier New', monospace; font-size: 20px; letter-spacing: .08em; }
  .how { font-size: 9px; color: #444; text-align: right; margin: 0; line-height: 1.5; }
  .toolbar { text-align: center; padding: 12px; } .toolbar button { padding: 10px 18px; font-weight: 700; cursor: pointer; }
  @media print { body { background: #fff; } .toolbar { display: none; } .sheet { margin: 0; } }
</style></head><body>
<div class="toolbar"><button onclick="window.print()">Print / Save as PDF</button> <small>Tip: print on white cardstock, then cut along the dashed lines.</small></div>
${pages.map((p) => `<div class="sheet">${p.map((g) => `<div class="slot">${card(g, origin)}</div>`).join("")}</div>`).join("")}
<script>window.onload = function(){ setTimeout(function(){ window.print(); }, 500); };</script>
</body></html>`;
  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.open(); w.document.write(html); w.document.close();
  return true;
}
